import React, { useEffect, useRef } from 'react';
import Portal from '../Portal';
import { Overlay } from './FeedbackStyled';

const body = document.querySelector('body');

const FeedbackModalWrap = (props: React.PropsWithChildren<{ onClose: () => void }>) => {
  const mousedownTarget = useRef<EventTarget>();
  const mouseupTarget = useRef<EventTarget>();
  const handleClose = () => {
    props.onClose && props.onClose();
  };
  const handleEscape = (e: KeyboardEvent) => {
    if (e.keyCode === 27) handleClose();
  };
  const handleClickOverlay = (e: React.MouseEvent) => {
    if (e.type === 'mousedown') {
      mousedownTarget.current = e.target;
    } else if (e.type === 'mouseup') {
      mouseupTarget.current = e.target;
    } else if (e.currentTarget === mousedownTarget.current && e.currentTarget === mouseupTarget.current) {
      handleClose();
    }
  };
  useEffect(() => {
    document.addEventListener('keydown', handleEscape);
    body?.classList.add('noScrollBody');
    return () => {
      document.removeEventListener('keydown', handleEscape);
      body?.classList.remove('noScrollBody');
    };
  }, [handleEscape]);

  return (
    <Portal>
      <Overlay onMouseUp={handleClickOverlay} onMouseDown={handleClickOverlay} onClick={handleClickOverlay}>
        {props.children}
      </Overlay>
    </Portal>
  );
};

export default FeedbackModalWrap;
